export default __webpack_public_path__ + "static/media/Prompt-Light.005f2ed2.ttf";